// extracted by mini-css-extract-plugin
export default {"fr-view":"Options_fr-view__e+C0t","options":"Options_options__alx+M"};